import { reducer, initialState } from "store/actions/reducer";
import { createStore } from "redux";

export const store = createStore(reducer, initialState)
